// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__WLIuM","col":"styles_col__LMRLb"};